import React from "react";
import { useState } from "react";
import { useContext } from "react";
import moment from "moment-timezone";
import StatisticAPIContext from "./contexts/StatisticAPIContext";
import { getLastNthDay } from "./helpers";

const stats_filters = [
  { value: 0, displayText: "Today" },
  { value: 7, displayText: "Last 7 days" },
  { value: 15, displayText: "Last 15 days" },
  { value: 30, displayText: "Last 30 days" }
];

const DataFilterBar = () => {
  const sourceTimeZone = moment.tz.zone(moment.tz.guess()).name;
  const { onGetData } = useContext(StatisticAPIContext);

  const [value, setValue] = useState(0);

  const onHandleDataChange = async (event) => {
    const dateOffset = event.target.value;
    const end_date = getLastNthDay(0);
    const start_date = getLastNthDay(dateOffset);

    const sourceStartDateTime = `${start_date} 00:00:00`;
    const sourceEndDateTime = `${end_date} 23:59:59`;

    const convertedStartDate = moment
      .tz(sourceStartDateTime, sourceTimeZone)
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");
    const convertedEndDate = moment
      .tz(sourceEndDateTime, sourceTimeZone)
      .utc()
      .format("YYYY-MM-DD HH:mm:ss");

    console.log(convertedStartDate, convertedEndDate);

    await onGetData({
      start_date: convertedStartDate,
      end_date: convertedEndDate
    });

    setValue(dateOffset);
  };

  return (
    <div className="filter-bar-container">
      <span>Statistics (Outbound calls only)</span>
      <select
        onChange={onHandleDataChange}
        className="select-box"
        value={value}
      >
        {stats_filters.map((filter) => (
          <option key={filter.value} value={filter.value}>
            {filter.displayText}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DataFilterBar;
